//** Import Modules */
import { Link } from "react-router-dom";

//** Import Assets */
// import logo from "../../assets/images/bizzll-logo-beta-red.png";
import logo from "../../assets/images/bizzll-logo.png";

import "../../assets/css/Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo" aria-label="Bizzll home">
            <img src={logo} alt="Bizzll" />
          </Link>
          <p className="site-footer__tagline">
            Connect, discover, and grow with local businesses.
          </p>
        </div>

        <nav className="site-footer__menu" aria-label="Footer navigation">
          <Link to="/terms-conditions">Terms and Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </nav>
      </div>

      <div className="site-footer__copyright">
        <p>&copy; Copyright BIZZLL 2026. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
